export const BASE_URL = process.env.REACT_APP_API_URL
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY || 'pk_test_51PTKyZKeFoXYlmxImRFAcbVKwzlvqvGLRBymmh79dDa2TvCe68OOYIHz2zM99cAoHWHqN1RF1rE0VMlah3cjqeEh00w7BvhcBw'
// For backwards compatibility
export const STRIPE_PUBLIK_KEY = STRIPE_PUBLIC_KEY
